export enum UserRoles {
    USER = 'USER',
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    COMPANY_MANAGER = 'COMPANY_MANAGER'
}
